import React, { useState } from "react";
import {
  Box,
  Typography,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTranslation } from "react-i18next";
import Japan from "../assets/Japan.svg"; // English flag
import spanish from "../assets/spanish.svg"; // Spanish flag

const LanguageSwitcher = ({ variant = "default" }) => {
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const language = i18n.language === "es" ? "   Español  " : "English";
  const currentFlag = language === "English" ? Japan : spanish;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleSelect = (lang) => {
    i18n.changeLanguage(lang === "English" ? "en" : "es");
    handleClose();
  };

  const getStyles = () => {
    switch (variant) {
      case "header":
        return {
          backgroundColor: "#091E420F",
          height: "43px",
          borderRadius: "4.34px",
          padding: "0px 18px 0px 18px",
          fontSize: "1rem",
          cursor: "pointer",
        };
      case "dashboard":
        return {
          backgroundColor: "transparent",
          height: "35px",
          borderRadius: "6px",
          padding: "0px 12px",
          fontSize: "14px",
          cursor: "pointer",
          border: "1px solid #E0E0E0",
        };
      default:
        return {
          backgroundColor: "#F8F9FA",
          height: "40px",
          borderRadius: "8px",
          padding: "0px 15px",
          fontSize: "14px",
          cursor: "pointer",
        };
    }
  };

  return (
    <>
      <Box
        onClick={handleClick}
        display="flex"
        flexDirection="row"
        justifyContent="flex-start"
        alignItems="center"
        gap={0.4}
        sx={getStyles()}
      >
        {/* <Box
          component="img"
          src={currentFlag}
          alt="Language Flag"
          sx={{ width: 20, height: 20, objectFit: "contain", mr: 1 }}
        /> */}
        <Typography
          variant="body2"
          sx={{
            fontSize: variant === "dashboard" ? 13 : 14,
            color: "#172B4D",
            fontWeight: 400,
            fontFamily: "Poppins, sans-serif",
          }}
        >
          {language}
        </Typography>
        <ExpandMoreIcon
          fontSize="small"
          sx={{ ml: 0.5, fontSize: variant === "dashboard" ? 16 : 18 }}
        />
      </Box>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{
          sx: {
            mt: 1,
            borderRadius: "10px",
            px: 0,
            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
            border: "1px solid #ccc",
            width: isMobile ? "140px" : isTablet ? "130px" : "110px",
          },
        }}
      >
        <MenuItem onClick={() => handleSelect("Spanish")} sx={{ gap: 1 }}>
          {/* <Box
            component="img"
            src={spanish}
            alt="Spanish"
            sx={{ width: 18, height: 18 }}
          /> */}
          <Typography
            variant="body2"
            sx={{
              fontSize: 14,
              color: "#172B4D",
              fontWeight: 400,
              fontFamily: "Poppins, sans-serif",
            }}
          >
          {t("spanish")}
          </Typography>
        </MenuItem>
        <MenuItem onClick={() => handleSelect("English")} sx={{ gap: 1 }}>
          {/* <Box
            component="img"
            src={Japan}
            alt="English"
            sx={{ width: 18, height: 18 }}
          /> */}
          <Typography
            variant="body2"
            sx={{
              fontSize: 14,
              color: "#172B4D",
              fontWeight: 400,
              fontFamily: "Poppins, sans-serif",
            }}
          >
           {t("english")}
          </Typography>
        </MenuItem>
      </Menu>
    </>
  );
};

export default LanguageSwitcher;
